import {storeToRefs} from 'pinia';
import {defineNuxtRouteMiddleware, navigateTo, useAuth} from '#imports';

export default defineNuxtRouteMiddleware(async (to) => {
    const auth = useAuth();
    const {getSelectedIdentity} = storeToRefs(auth);

    const freelancerIdentityId = getSelectedIdentity.value?.id;

    return await navigateTo('/freelancer/' + freelancerIdentityId);
});
